import React from 'react';
import axios from 'axios';
import { Grid, Table, Modal, Button,  Dimmer, Loader, Segment } from 'semantic-ui-react';
import { NoData } from "../../components/table/no-data";
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";

import { apiUrl } from "../../config.js"
import { AuthService } from '../../services/auth-service'
import { FilePond } from 'react-filepond';
import * as api from '../../api'
const authService = new AuthService();

class DataMapsTableRow extends React.Component {
    
    constructor(props) {
        super(props);

        this.state = {
            dataProvider: new ApiDataProvider(api.getCustomerMeters, [this.props.customerId]),
            metersCount: {},
            completenessData: [],
            gasMeterCount: [],
            elecMeterCount: [],
            waterMeterCount: [],

            UpdateMe: "ready",
            showInfoHide: false,
            showErrorHide: true,
            showSuccessHide: true,
            uploadStatusList: ["error1", "error2"],
            downloadingFile : false,
            meterModalOpen : false
        }
    }


    setOpen = (open) => {
        if(open === false)
        {
            this.setState({
        
                showInfoHide : false,
                showErrorHide : true,
                showSuccessHide  : true,
            });
        }
        this.setState({
        
            meterModalOpen : open
        });
    }

    downloadDocument = (mapName) => {
        this.setState({
        
            downloadingFile : true
        });
        axios({
            url: `${apiUrl}/DataMaps/GetMapData/${mapName}`,
            method: 'POST',       // Worked using POST or PUT. Prefer POST
            headers: {
                'Authorization': `bearer ${localStorage.getItem("token")}`
            },
            responseType: 'blob', // important
        }).then((response) => {
            this.setState({
        
                downloadingFile : false
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', mapName + '.csv');
            document.body.appendChild(link);
            link.click();
        });
    }

    render() {
        

        return (
            <Table.Row>
                <Table.Cell>{this.props.data.name || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.description || <NoData />}</Table.Cell>
                <Table.Cell>{this.props.data.mapSource || <NoData />}</Table.Cell>
                <Table.Cell>
                <Button.Group compact floated='right'>
                                <Modal size="small"
                                    trigger={<Button small floated='right' id='upload-meters'>Download/Upload Map Data</Button>}
                                    onOpen={() => this.setOpen(true)}
                                    open={this.state.meterModalOpen}
                                    >
                                    <Modal.Header>
                                        <h2>Download/Upload Map Data</h2>
                                    </Modal.Header>
                                    <Modal.Content>
                                    <div>
                                    <Segment>

<Dimmer active={this.state.downloadingFile}>
    <Loader>Preparing File</Loader>
</Dimmer>
                                               
                                        <div className="ui info message" hidden={this.state.showInfoHide}>
                                            <i className="ui visible icon"></i>
                                            <div className="header">Download Current Populated Map Data
                                        </div>
                                           <br/>
                                               
                                                <div>                        <Button icon='download' onClick={() => this.downloadDocument(this.props.data.mapSource)} color='green'></Button>
                                                </div>
                                          
                                        </div>
                                        <div className="ui error message" hidden={this.state.showErrorHide}>
                                            <div className="header">
                                                There were some errors with your submission
  </div>
                                            <ul className="list">
                                                {this.state.uploadStatusList.map((listitem,index) => (
                                                    <li key={index} className="list-group-item list-group-item-primary">
                                                        {listitem}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div className="ui positive message" hidden={this.state.showSuccessHide}>
                                            <div className="header">
                                                 Map sucessfully submitted
  </div>
                                            <ul className="list">
                                                {this.state.uploadStatusList.map((listitem,index) => (
                                                    <li key={index} className="list-group-item list-group-item-primary">
                                                        {listitem}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <Grid verticalAlign='middle'>
                                            <Grid.Row>
                                                <Grid.Column>
                                                    <FilePond onupdatefiles={this.onFilesUpdated} allowMultiple={false} allowRevert={false} allowRemove={false} allowProcess={false} 
                                                      acceptedFileTypes={[
                                                        
                                                        'text/csv' // .csv
                                                    ]}
                                                    server={{
                                                        process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
                                                            this.setState({ showInfoHide: true })
                                                            const formData = new FormData();
                                                            formData.append(fieldName, file, file.name);
                                                            formData.append("client", authService.getUserData(AuthService.CUSTOMER_ID_KEY));
                                                            formData.append("uploadedBy", authService.getUserData(AuthService.EMAIL_KEY));
                                                            const request = new XMLHttpRequest();

                                                            request.open('POST', `${apiUrl}/DataMaps/UploadDataMap/${this.props.data.mapSource}`);
                                                            request.setRequestHeader(
                                                                'Authorization', `bearer ${localStorage.getItem("token")}`);

                                                            request.upload.onprogress = (e) => {
                                                                progress(e.lengthComputable, e.loaded, e.total);

                                                            };

                                                            request.onload = (e) => {
                                                              

                                                                var obj = JSON.parse(e.srcElement.response);

                                                                if (obj.status === 'Success') {

                                                                   
                                                                        this.setState({
                                                                            showSuccessHide: false,
                                                                            uploadStatusList:  ["Map successfully updated"]
                                                                        })
                                                                        load("Success");
                                                                    

                                                                }
                                                                else {

                                                                    this.setState({
                                                                        showErrorHide: false,
                                                                        uploadStatusList: ["failed upload please check the file format."]
                                                                    })
                                                                    error('failed upload please check the file format.');
                                                                }
                                                            };

                                                            request.send(formData);

                                                            return {

                                                                abort: () => {
                                                                    request.abort();
                                                                    abort();
                                                                }
                                                            };
                                                        }
                                                    }} />
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                        </Segment>
                                        </div>
                                        
                                    </Modal.Content>
                                    <Modal.Actions>
        <Button color='black' onClick={() => this.setOpen(false)}>
          Dismiss
        </Button>
        
      </Modal.Actions>
                                </Modal>
                            </Button.Group>
        </Table.Cell>
            </Table.Row>
        );
    }
}

export default DataMapsTableRow;